import React from 'react';
import { footerLinks } from '../data/content';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-navy-dark px-5 py-14" data-id="element-112" data-mp="3geze367ujv27">
      <div className="mx-auto max-w-5xl text-center" data-id="element-113" data-mp="3gh3n22klrk9c">
        <p className="font-display text-xl font-black uppercase tracking-tight text-white" data-id="element-114" data-mp="32p5m4f11ouo9">
          <span aria-hidden="true" data-id="element-115" data-mp="36qhdoq3hbpz3">♫ </span>Musica Pronta
        </p>
        <p className="mx-auto mt-3 max-w-md text-xs leading-relaxed text-white/55" data-id="element-116" data-mp="3ufa64ckw7foy">
          La risorsa definitiva per i docenti di musica che amano il loro
          lavoro.
        </p>
        <nav aria-label="Footer" data-id="element-117" data-mp="3lec9ifcsaage">
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-white/65" data-id="element-118" data-mp="3ldamrdmenziu">
            {footerLinks.map(link => <li key={link} data-id="element-119" data-mp="29zgjjx8osmkj">
                <a href="#offerta" className="transition-colors hover:text-tangerine" data-id="element-120" data-mp="29y5fdwbbxcsw">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-white/40" data-id="element-121" data-mp="3lbdecxo1ahnx">
          © 2026 Musica Pronta — Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}